// ============================================
// FILE: src/utils/quantityHelpers.js
// ============================================
//
// Apparel and gardening products are bought in counts that don't fit the
// grocery-style 1 / 2 / 3 / 4 quick picks (a dozen saplings, five T-shirts for
// a team), so they get a quantity text box instead.

export const QUANTITY_MIN = 1;
export const QUANTITY_MAX = 99;

const isTruthyFlag = (value) => (
  value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true'
);

/** True for products flagged is_apparel or is_gardening. */
export const usesQuantityTextBox = (product) => (
  !!product && (isTruthyFlag(product.is_apparel) || isTruthyFlag(product.is_gardening))
);

/** Whole number clamped to [QUANTITY_MIN, QUANTITY_MAX]; null for no number. */
export const parseQuantity = (raw) => {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (!digits) return null;
  return Math.min(QUANTITY_MAX, Math.max(QUANTITY_MIN, parseInt(digits, 10)));
};
